<template>
  <div>
    <v-layout justify-center mb-3>
      <span :class="(!colorClass ? '' : colorClass + ' ') + 'text-xs-center textoAjustado'" xs2 style="font-size:19px"><slot></slot></span>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'o-description-title',
  props: {
    colorClass: {
      default: 'grey--text'
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/generic/titulos/ODescriptionTitle.vue